import { render, staticRenderFns } from "./Work1To1.vue?vue&type=template&id=4e961026&"
import script from "./Work1To1.vue?vue&type=script&lang=js&"
export * from "./Work1To1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports